/*
 * <utsav-countdown data-end="2026-11-08T23:59:59+05:30">
 * Counts down to data-end (ISO 8601 with offset, so the end moment is absolute, e.g. IST),
 * updates every second and hides itself once the time is up (kept visible in the theme editor).
 */
(() => {
  if (customElements.get('utsav-countdown')) return;

  const pad = (value) => String(value).padStart(2, '0');

  class UtsavCountdown extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);

      // An unparseable end date would leave "00" boxes on screen; hide the strip instead (keep it in the editor).
      if (Number.isNaN(this.end)) {
        if (!(window.Shopify && window.Shopify.designMode)) this.hidden = true;
        return;
      }

      this.nums = {};
      this.querySelectorAll('[data-unit]').forEach((el) => {
        this.nums[el.dataset.unit] = el;
      });

      this.tick();
      this.timer = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    tick() {
      const remaining = Math.max(0, this.end - Date.now());
      const total = Math.floor(remaining / 1000);

      this.nums.days.textContent = pad(Math.floor(total / 86400));
      this.nums.hours.textContent = pad(Math.floor((total % 86400) / 3600));
      this.nums.minutes.textContent = pad(Math.floor((total % 3600) / 60));
      this.nums.seconds.textContent = pad(total % 60);

      if (remaining === 0) {
        window.clearInterval(this.timer);
        if (!(window.Shopify && window.Shopify.designMode)) this.hidden = true;
      }
    }
  }

  customElements.define('utsav-countdown', UtsavCountdown);
})();
